import React from 'react';
import { IFeeWaiverHistoryItem } from './interfaces';
import styles from './index.module.scss';
import { Tag, Typography } from '@navi/web-ui/lib/primitives';
import { formatAmount } from '@cp/src/utils/commonUtils';
import dayjs from 'dayjs';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { DateFormat } from '@cp/src/utils/DateHelper';

const FeeWaiverHistoryItem: React.FC<IFeeWaiverHistoryItem> = ({ feeWaiverItem, isLastItem }) => {
  const {
    agentName,
    agentReferenceId,
    waivedAmount,
    emiDate,
    createdAt,
    reappliedAt,
    waiveStatus
  } = feeWaiverItem || {};
  const userId = useSelector((state: RootState) => state?.common?.userData?.referenceId);
  const isUserMyself = agentReferenceId === userId;
  return (
    <div
      className={cx('py-5 border-0 border-dashed border-border', {
        'border-b': !isLastItem
      })}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-start w-4/5">
          <div className={cx(styles.dot, styles['dot--green'])} />
          <Typography variant="p5" color={'var(--grayscale-7)'} className="truncate flex-1">
            <Typography variant="h4" as="span">
              {waiveStatus}
            </Typography>{' '}
            by {isUserMyself ? 'You' : agentName}
            <Typography variant="h6" color="var(--grayscale-2)">
              for EMI - {dayjs(emiDate).format(DateFormat.LONG_DATE_FORMAT_WITHOUT_TIME)}
            </Typography>
            {dayjs(createdAt).format('DD MMM, YYYY [at] hh:mm a')}
          </Typography>
        </div>
        <Typography variant="h4">{formatAmount(waivedAmount)}</Typography>
      </div>
      {reappliedAt ? (
        <div className="flex ml-4 mt-1">
          <div className={styles.pointerLine} />
          <div className="mt-3">
            <Tag
              variant="transparent"
              label={`Reapplied at ${dayjs(reappliedAt).format(DateFormat.DD_MMM_hh_mm_A)}`}
              startAdornment={<div className={cx(styles.dot, styles['dot--orange'])} />}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FeeWaiverHistoryItem;
